import { render, staticRenderFns } from "./flow8.vue?vue&type=template&id=edd30232&scoped=true&"
import script from "./flow8.vue?vue&type=script&lang=js&"
export * from "./flow8.vue?vue&type=script&lang=js&"
import style0 from "./flow8.vue?vue&type=style&index=0&id=edd30232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd30232",
  null
  
)

export default component.exports